import React, { FC, useEffect } from 'react'
import {
	NotificationItemComponent,
	NotificationPopupModel,
	notificationPopupSlice,
	notificationPopupSelector,
} from 'Modules'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'Src/hooks/useAppDispatch'
import { useEffectOnce } from 'Src/hooks/useEffectOnce'
import { NotificationWrapper } from './styled'

let timerId = null

const actions = {
	updateTimerNotification: notificationPopupSlice.actions.updateTimer,
}

const NotificationPopupComponent: FC = () => {
	const notifications = useSelector(notificationPopupSelector.getAllView)
	const { updateTimerNotification } = useAppDispatch(actions)
	useEffectOnce(() => {
		return () => {
			if (timerId) clearInterval(timerId)
		}
	})
	useEffect(() => {
		if (timerId && !notifications.length) {
			clearInterval(timerId)
			timerId = null
		}
		if (!timerId && notifications.length) {
			timerId = setInterval(() => updateTimerNotification(), 1000)
		}
	}, [notifications.length, updateTimerNotification])

	return (
		<>
			{Boolean(notifications.length > 0) && (
				<NotificationWrapper data-qa="right_notification">
					{notifications.map((item: NotificationPopupModel, index) => (
						<NotificationItemComponent item={item} index={index} />
					))}
				</NotificationWrapper>
			)}
		</>
	)
}

export const NotificationPopup = NotificationPopupComponent
